import React, { useState } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    borders, colors, space, radii, mediaQueries
} from 'style/config';
import Empty from 'constants/empty';
import BundleHeader from 'components/ProductPage/PdpBundling/BundleWidget/BundleHeader';
import BundleProductCard from 'components/ProductPage/PdpBundling/BundleWidget/BundleProductCard';
import PriceTotal from 'components/ProductPage/PdpBundling/BundleWidget/PriceTotal';
import AddAllButton from 'components/ProductPage/PdpBundling/BundleWidget/AddAllButton';

const BUNDLE_DATA_SOURCE = {
    Manual: 'Manual',
    Automated: 'Automated',
    Off: 'Off'
};

const BundleWidget = ({ currentProduct }) => {
    // TODO FER-790: field names will change when BE completes FER-586.
    const { productBundleDataSource, useItWithTitle, ancillarySkus = Empty.Array, currentSku } = currentProduct || Empty.Object;

    let bundleProducts = Empty.Array;

    if (productBundleDataSource === BUNDLE_DATA_SOURCE.Automated) {
        // TODO FER-710: return Constructor.io data
    } else if (productBundleDataSource === BUNDLE_DATA_SOURCE.Manual) {
        bundleProducts = ancillarySkus.filter(sku => !sku.isOutOfStock);
    }

    const [deselectedSkuIds, setDeselectedSkuIds] = useState(new Set());

    if (!bundleProducts.length) {
        return null;
    }

    const handleCheckboxChange = skuId => {
        setDeselectedSkuIds(prev => {
            const next = new Set(prev);
            next.has(skuId) ? next.delete(skuId) : next.add(skuId);

            return next;
        });
    };

    const selectedBundleProducts = bundleProducts.filter(sku => !deselectedSkuIds.has(sku.skuId));
    const hasSelection = selectedBundleProducts.length > 0;

    return (
        <section css={styles.container}>
            <BundleHeader title={useItWithTitle} />
            <div css={styles.widgetCard}>
                <div css={styles.productsWrapper}>
                    <BundleProductCard
                        product={currentSku}
                        isCurrentProduct
                    />
                    {bundleProducts.map(sku => (
                        <BundleProductCard
                            key={sku.skuId}
                            product={sku}
                            isChecked={!deselectedSkuIds.has(sku.skuId)}
                            onCheckboxChange={() => handleCheckboxChange(sku.skuId)}
                        />
                    ))}
                </div>
                <div css={styles.footer}>
                    <PriceTotal
                        currentProduct={currentSku}
                        bundleProducts={selectedBundleProducts}
                    />
                    <AddAllButton disabled={!hasSelection} />
                </div>
            </div>
        </section>
    );
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: space[4],
        marginTop: space[4],
        [mediaQueries.sm]: {
            marginTop: space[5]
        }
    },
    widgetCard: {
        display: 'flex',
        flexDirection: 'column',
        gap: space[3],
        width: '100%',
        border: `${borders[1]} ${colors.lightGray}`,
        borderRadius: radii[3],
        overflow: 'hidden',
        paddingBottom: space[4],
        [mediaQueries.sm]: {
            flexDirection: 'row',
            padding: space[5],
            gap: 0
        }
    },
    productsWrapper: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        [mediaQueries.sm]: {
            flex: 1,
            flexDirection: 'row',
            '& > *': {
                flex: 1
            },
            '& > *:not(:first-of-type)': {
                borderLeft: `${borders[1]} ${colors.lightGray}`,
                paddingLeft: space[5],
                paddingRight: space[5]
            }
        }
    },
    footer: {
        display: 'flex',
        flexDirection: 'column',
        gap: space[4],
        padding: `0 ${space[4]}px`,
        width: '100%',
        [mediaQueries.sm]: {
            padding: 0,
            paddingLeft: space[6],
            width: 'auto',
            justifyContent: 'center',
            borderLeft: `${borders[1]} ${colors.lightGray}`
        }
    }
};

export default wrapFunctionalComponent(BundleWidget, 'BundleWidget');
